import { put, takeLatest } from "redux-saga/effects";
import { updateCountry } from "./actions";
import { getCountryByCode } from "./countries";
import { CountryActionTypes } from "./constants";

function* changeCountry(action: { payload: string }) {
  const countryCode = action.payload;
  const country = getCountryByCode(countryCode);

  if (country) {
    const { name, flag } = country;
    localStorage.setItem(
      "country",
      JSON.stringify({ code: countryCode, name, flag })
    );
    yield put(updateCountry(countryCode, name, flag));
  } else {
    console.error(`Country code ${countryCode} not found`);
  }
}

function* countrySaga() {
  // takeLatest(actionType, saga) — TS wrongly picks channel overload; runtime is correct
  // @ts-expect-error redux-saga overload resolution treats enum as TakeableChannel
  yield takeLatest(CountryActionTypes.CHANGE_COUNTRY, changeCountry);
}

export default countrySaga;
